jQuery(document).ready(function() {
  jQuery(document).on('click', '.fil-icons .collectiongrid-layout', function(event) {
    var dataIdValue = jQuery(this).data('id');
    jQuery('.fil-icons .collectiongrid-layout').removeClass('active');
    jQuery(this).addClass('active');
    if(dataIdValue == "collectiongrid-layout-2"){
      jQuery('#product-grid').removeClass().addClass('grid product-grid grid--2-col-tablet-down grid--2-col-desktop');
    } else if(dataIdValue == "collectiongrid-layout-3"){
      jQuery('#product-grid').removeClass().addClass('grid product-grid grid--2-col-tablet-down grid--3-col-desktop');
    } else if(dataIdValue == "collectiongrid-layout-4"){
      jQuery('#product-grid').removeClass().addClass('grid product-grid grid--2-col-tablet-down grid--4-col-desktop');
    } else if(dataIdValue == "collectiongrid-layout-1"){
      jQuery('#product-grid').removeClass().addClass('grid product-grid grid--1-col-tablet-down grid--1-col-desktop list-view');
    }
  });

  jQuery(document).on('click', 'span.footer-title.ishi-collapse', function() {
    jQuery(this).find('.fa').toggleClass('fa-chevron-down fa-chevron-up');
    var id = jQuery(this).attr('data-href');
    jQuery(id).slideToggle('slow');
  });

  jQuery(document).on('click', '.card__media .media img', function() {
      var href_val = jQuery(this).parent().parent().parent().find('.card__heading').find('a').attr('href');
  });
  setTimeout(function(){
    jQuery('.jdgm-prev-badge__text').append('<img src="https://cdn.shopify.com/s/files/1/0505/3559/6226/files/veried.png?v=1707976272" width="20px">');
  }, 2000);


  
});